var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-cell-group",
    { staticClass: "updateName" },
    [
      _c("van-field", {
        staticClass: "nickName",
        attrs: { placeholder: "请输入昵称" },
        model: {
          value: _vm.nickName,
          callback: function($$v) {
            _vm.nickName = $$v
          },
          expression: "nickName"
        }
      }),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "ModifyName",
              attrs: { round: "", type: "danger", size: "large" },
              on: { click: _vm.ModifyName }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3db8358c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db8358c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Settings/UpdateName.vue
// module id = null
// module chunks = 